module.exports = __webpack_public_path__ + "static/media/sketchPhoto.b68755b3.png";